import React, { useEffect, useRef, InputHTMLAttributes, useState } from 'react';
import { useField } from '@unform/core';
import { Container } from './styles';
import theme from '../../../styles/ThemeComponents';

interface Props extends InputHTMLAttributes<HTMLInputElement> {
  style?: Record<string, any>;
  name: string;
  unique?: boolean;
  preText?: JSX.Element;
  posText?: JSX.Element;
  background_line?: string;
  setCallBack?: Function;
  options: {
    id: string;
    value: string;
    label: string;
    sub_title?: string;
  }[];
}
const CheckboxInput: React.FC<Props> = ({
  name,
  options,
  preText = '',
  posText = '',
  unique = false,
  style,
  background_line = '',
  setCallBack = (value) => { },
  ...rest
}) => {
  const selectRef = useRef(null);
  const { fieldName, registerField, defaultValue = [] } = useField(name);
  const [value, setValue] = useState('');
  useEffect(() => {
    registerField({
      name: fieldName,
      ref: selectRef.current,
      path: undefined,
      getValue: (refs) => {
        return value;
      },

      setValue: (refs: HTMLInputElement[], values: string) => {
        setValue(values)
      },
    });
  }, [defaultValue, value, fieldName, registerField]);
  return (
    <Container style={style} {...rest}>
      {preText && <label style={{ border: '0', textAlign: 'justify', color: theme.color }}>{preText}</label>}
      {options.map((option, index) => (
        <label onClick={(e) => {
          setValue(option?.value)

        }} style={{ cursor: 'pointer', color: theme.color, width: '100%', background: background_line ? background_line : 'none', padding: "10px", maxWidth: '120px' }} htmlFor={`${name}_${option.value}`} key={`label-${name}_${option.value}`}>
          <input style={{ minWidth: '20px', width: '20px', color: theme.color, border: '1px solid#333' }}

            checked={value === option?.value}

            value={option.value}
            type="checkbox"

            key={`${name}_${option.value}`}
          />
          <div style={{ display: 'flex', flexDirection: 'column', justifyContent: 'center', alignItems: 'flex-start', marginLeft: '10px' }}>
            <strong style={{ color: theme.color, fontSize: '12px' }}>{option.label}</strong>
            {option.sub_title && <p style={{ color: theme.color, fontSize: '11px' }}>{option.sub_title}</p>}
          </div>
        </label>
      ))}
      {posText && <label style={{ border: '0', textAlign: 'justify', color: theme.color }}>{posText}</label>}
    </Container>
  );
};
export default CheckboxInput;
